import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { StoryCardSmall } from "./components/StoryCardSmall/storyCardSmall";
import { StoryCardLarge } from "./components/StoryCardLarge/storyCardLarge";
var StoryCard = function(param) {
    var title = param.title, topic = param.topic, creator = param.creator, backgroundImg = param.backgroundImg, ellipseImg = param.ellipseImg, _variant = param.variant, variant = _variant === void 0 ? "small" : _variant, isExternalImages = param.isExternalImages, ignoreSize = param.ignoreSize;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            variant === "small" && /*#__PURE__*/ _jsx(StoryCardSmall, {
                title: title,
                topic: topic,
                creator: creator,
                backgroundImg: backgroundImg,
                ellipseImg: ellipseImg,
                isExternalImages: isExternalImages,
                ignoreSize: ignoreSize
            }),
            variant === "large" && /*#__PURE__*/ _jsx(StoryCardLarge, {
                title: title,
                topic: topic,
                creator: creator,
                backgroundImg: backgroundImg,
                ellipseImg: ellipseImg,
                isExternalImages: isExternalImages,
                ignoreSize: ignoreSize
            })
        ]
    });
};
export default StoryCard;
